import { PreguntaPrimerNivel } from './pregunta-primer-nivel'
import { Prospecto } from './prospecto'
import { JsonConverter } from '../JsonConverter'
import { PreguntaSecundaria } from 'app/dominio/pregunta-secundaria'
import { Conclusion } from './conclusion'

export class Declaracion implements JsonConverter {

  private _idSolicitud: string
  private _prospecto: Prospecto
  private _preguntasPrimerNivel: PreguntaPrimerNivel[]
  private _preguntasSecundarias: PreguntaSecundaria[]
  private _conclusiones: Conclusion[]
  private _fecha: string
  private _ramo: string
  private _subRamo: string
  private _canal: string
  private _deltaPeso: number
  private _nomOcupacion: string

  constructor (
    idSolicitud: string,
    prospecto: Prospecto,
    preguntasPrimerNivel: PreguntaPrimerNivel[],
    preguntasSecundarias: PreguntaSecundaria[],
    conclusiones: Conclusion[],
    fecha: string,
    ramo: string,
    subRamo: string,
    canal: string,
    deltaPeso: number,
    nomOcupacion: string
  ) {
    this._idSolicitud = idSolicitud
    this._prospecto = prospecto
    this._preguntasPrimerNivel = preguntasPrimerNivel
    this._preguntasSecundarias = preguntasSecundarias
    this._conclusiones = conclusiones
    this._fecha = fecha
    this._ramo = ramo
    this._subRamo = subRamo
    this._canal = canal
    this._deltaPeso = deltaPeso
    this._nomOcupacion = nomOcupacion
  }

  get idSolicitud(): string {
    return this._idSolicitud
  }

  get prospecto(): Prospecto {
    return this._prospecto
  }

  get preguntasPrimerNivel(): PreguntaPrimerNivel[] {
    return this._preguntasPrimerNivel
  }

  get preguntasSecundarias(): PreguntaSecundaria[] {
    return this._preguntasSecundarias
  }

  get conclusiones(): Conclusion[] {
    return this._conclusiones
  }

  get fecha(): string {
    return this._fecha
  }

  get ramo(): string {
    return this._ramo
  }

  get subRamo(): string {
    return this._subRamo
  }

  get canal(): string {
    return this._canal
  }

  get deltaPeso(): number {
    return this._deltaPeso
  }

  get nomOcupacion(): string {
    return this._nomOcupacion
  }

  toJson() {
    return {
      idSolicitud: this.idSolicitud,
      prospecto: this.prospecto.toJson(),
      preguntasPrimerNivel: this.preguntasPrimerNivel.map( p => p.toJsonD() ),
      preguntasSecundarias: this.preguntasSecundarias,
      conclusiones: this.conclusiones.map( c => c.toJson()),
      ramo: this._ramo,
      subRamo: this._subRamo,
      canal: this._canal,
      deltaPeso: this._deltaPeso
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/dominio/declaracion.ts